import { List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'
import { formatDate } from 'helpers/formatter'

// state
const initialState = fromJS({
  data: [],
  min: 0,
  max: 0,
  startMortalityDate: null,
  endMortalityDate: null,
})

// constants
export const MORTALITY_LIST = 'mortality/MORTALITY_LIST'
export const [
  MORTALITY_LIST_REQUEST,
  MORTALITY_LIST_SUCCESS,
  MORTALITY_LIST_FAILURE,
] = [
  `${MORTALITY_LIST}_REQUEST,`,
  `${MORTALITY_LIST}_SUCCESS`,
  `${MORTALITY_LIST}_FAILURE`,
]

const MORTALITY_PERIOD = 'mortality/MORTALITY_PERIOD'

export const mortalityList = ActionHelper.createActionObj(MORTALITY_LIST)
export const mortalityPeriod = ActionHelper.createActionObj(MORTALITY_PERIOD)

// reducers
const mortality = handleActions(
  {
    [MORTALITY_LIST_SUCCESS]: (state, action) =>
      state
        .set('data', List(action.payload.data))
        .set('min', action.payload.min)
        .set('max', action.payload.max),
    [MORTALITY_PERIOD]: (state, action) =>
      state
        .set(
          'startMortalityDate',
          formatDate(new Date(action.payload.firstDate * 1000)),
        )
        .set(
          'endMortalityDate',
          formatDate(new Date(action.payload.lastDate * 1000)),
        ),
    [RESET_STORE]: () => initialState,
  },
  initialState,
)

export default mortality
